// Multilingual content for the link-redemption confirmation/denial landing page.
//
// NOTE FOR THE TEAM: these are TEMPLATE copies — the Spanish (es) strings are the
// ones provided so far; en/ca are first drafts to be reviewed/polished.
//
// The landing page renders one of the three states below based on the `status`
// query param the API redirect appends:
//   ?status=redeemed | already_redeemed | error
// Language is picked by getLocalizedContent (?lang=es|en|ca or browser language).

export const linkRedeemedContent = {
  // Happy path — first valid click, request stored.
  redeemed: {
    variant: 'success',
    title: {
      es: 'Hemos guardado tu petición',
      en: "We've saved your request",
      ca: 'Hem desat la teva petició',
    },
    description: {
      es: 'Recibirás el reembolso de tu entrada hasta 7 días después.',
      en: "You'll receive the refund for your ticket within 7 days.",
      ca: 'Rebràs el reemborsament de la teva entrada fins a 7 dies després.',
    },
  },

  // Bad path — code was already redeemed before.
  already_redeemed: {
    variant: 'info',
    title: {
      es: 'Ya hemos recibido tu petición anteriormente',
      en: 'We already received your request',
      ca: 'Ja hem rebut la teva petició anteriorment',
    },
    description: {
      es: 'Pronto recibirás tu reembolso.',
      en: "You'll receive your refund soon.",
      ca: 'Aviat rebràs el teu reemborsament.',
    },
  },

  // Bad path — invalid/expired code or unexpected failure.
  error: {
    variant: 'error',
    title: {
      es: 'Oops, algo ha ocurrido',
      en: 'Oops, something went wrong',
      ca: 'Ups, alguna cosa ha fallat',
    },
    description: {
      es: 'Vuelve a intentarlo.',
      en: 'Please try again.',
      ca: 'Torna-ho a provar.',
    },
  },
}

export default linkRedeemedContent
